import { ActionTypes } from "../contants/action-type";

const initialState = {
    businesscategories: [],
    businesscategory: {}
}

export const RegistrationReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.LIST_BUSINESS_CATEGORY:
            return { ...state, businesscategories: payload };
        default:
            return state;
    }
}